import { bffERInstance } from "../v2/api/axiosInstance";
import { useQuery } from "react-query";

const sleep = (ms:any) => new Promise((resolve) => setTimeout(resolve, ms));

export const getERApplication = async () => {
  const randomDelay = Math.floor(Math.random() * (20000 - 10 + 1) + 10);
  await sleep(randomDelay);
  const response = await bffERInstance.get(
    `/getERUserAppsAndWorkflows`
  );
  return response.data;
};

export const useGetERApplication = () => {

  const query = useQuery({
    queryKey: ["getERApplications"],
    queryFn: () => getERApplication()
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };

};
